var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icons-collage"},[_vm._l((_vm.icons),function(icon,i){return _c('div',{key:i,staticClass:"icons-collage__icon",style:({
      top: icon.top,
      left: icon.left
    })},[_c('img',{attrs:{"src":icon.icon,"width":icon.width,"alt":""}})])}),_c('div',{staticClass:"icons-collage__content"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }